import { NgModule } from '@angular/core';


import { DesktopMenuComponent } from './desktop-menu/desktop-menu.component';
import { MobileMenuComponent } from './mobile-menu/mobile-menu.component';
import { SharedCommonModule } from '@shared/shared-common.module';

@NgModule({
    declarations: [
        DesktopMenuComponent,
        MobileMenuComponent
    ],
    imports: [
        SharedCommonModule
    ],
    exports: [
        DesktopMenuComponent,
        MobileMenuComponent
    ]
})
export class MenuModule { }
